<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <DeploymentInfo />
  </div>
</template>

<script setup lang="ts">
const flagsStore = useFlagsStore()
const appStore = useAppStore()

await callOnce('app-init', async () => {
  await Promise.all([flagsStore.fetchFlags(), appStore.fetchCountries()])
})

const { $htmlLang, $hrefLangLinks, $flags } = useNuxtApp()

const cookiebotCulture = computed(() => {
  const locale = appStore.locale
  return locale === 'no' ? 'nb' : locale
})

const isDataProtocolEnabled = computed(() => $flags.isEnabled({ name: 'load_data_protocol_script' }))

const { public: { DATA_PROTOCOL_URL } } = useRuntimeConfig()

useHead({
  htmlAttrs: {
    lang: $htmlLang
  },
  link: $hrefLangLinks,
  script: computed(() => [
    {
      key: 'cookiebot',
      id: 'Cookiebot',
      src: 'https://consent.cookiebot.com/uc.js',
      type: 'text/javascript',
      ['data-cbid']: '0b6e9c22-7c32-46ab-aebf-9b0cf9bf2156',
      ['data-culture']: cookiebotCulture.value
    } as any,
    ...(isDataProtocolEnabled.value
      ? [{ key: 'data-protocol', src: DATA_PROTOCOL_URL, type: 'text/javascript', async: true } as any]
      : [])
  ]),
  style: [
    {
      key: 'cookiebot-styles',
      type: 'text/css',
      innerHTML:
        'a#CybotCookiebotDialogPoweredbyCybot, div#CybotCookiebotDialogPoweredByText { display: none !important; } #CookiebotWidget .CookiebotWidget-body .CookiebotWidget-main-logo { display: none !important; } .CookiebotWidget-main-logo { display: none !important; }'
    } as any
  ]
})
</script>
